export default {
    "defaultGameSlug": "feast"
    // "defaultGameSlug": "hero"
}
